/* globals google */

const mapElm = document.querySelector<HTMLDivElement>('#map');
const apiKey = 'AIzaSyCtthGEUjq7wWQsS7Y4S0jhB9sW8HacFWc';
const aspectRatio = 0.375;
const geoLocation = {
	latitude: 51.017062,
	longitude: 5.89784,
};

/**
 * Loads the Maps script asynchronously.
 * @param callback Callback function
 */
function loadApi(callback: () => void) {
	const callbackFunction = 'googleMapsInit';
	const source = `https://maps.googleapis.com/maps/api/js?callback=${callbackFunction}&key=${apiKey}&libraries=marker&loading=async`;

	// Register global init callback

	const globalWithCallback = globalThis as unknown as Record<
		string,
		() => void
	>;
	globalWithCallback[callbackFunction] = callback;

	// Append script
	const script = document.createElement('script');
	script.async = true;
	script.src = source;
	document.body.append(script);
}

/**
 * Sets the dimensions of the map element based on its aspect ratio.
 */
function setDimensions() {
	if (!mapElm) {
		return;
	}

	const width = mapElm.parentElement?.offsetWidth ?? 0;
	const height = Math.round(width * aspectRatio);
	mapElm.style.width = `${width}px`;
	mapElm.style.height = `${height}px`;
}

/**
 * Adds a map to an element.
 */
function initializeMap() {
	if (!mapElm) {
		return;
	}

	mapElm.classList.remove('consent-request');
	loadApi(() => {
		if (typeof google === 'undefined') {
			return;
		}

		// Set the dimensions of the map element
		setDimensions();

		// Initialize the map
		const googleMap = new google.maps.Map(mapElm, {
			mapTypeId: google.maps.MapTypeId.SATELLITE,
			center: new google.maps.LatLng(
				geoLocation.latitude,
				geoLocation.longitude,
			),
			zoom: 16,
			streetViewControl: false,
			scrollwheel: false,
			zoomControl: false,
			fullscreenControl: false,
			mapTypeControl: false,
			cameraControl: false,
			mapId: 'DEMO_MAP_ID',
		});

		// Add marker to the map
		const marker = new google.maps.marker.AdvancedMarkerElement({
			position: new google.maps.LatLng(
				geoLocation.latitude,
				geoLocation.longitude,
			),
			map: googleMap,
		});
		marker.title = 'Westzipfelhalle Tüddern';

		// Resize map on window resize
		window.addEventListener('resize', () => {
			// Apply new height based on existing aspect ratio
			setDimensions();

			// Re-center the map
			const center = googleMap.getCenter() ?? new google.maps.LatLng(0, 0);
			google.maps.event.trigger(googleMap, 'resize');
			googleMap.setCenter(center);
		});
	});
}

const renderConsent = (container: HTMLElement, callback: () => void) => {
	container.classList.add('consent-request');
	container.innerHTML = `
		<div class="consent-toggle">
			<button type="button">Karte anzeigen</button>
		</div>
		<div class="consent-details">
			<p>Wir verwenden die Google Maps API, um geografische Informationen visuell darzustellen. Mit Klick auf den Button stimmen Sie zu, dass von Google Daten über die Nutzung der Kartenfunktionen erhoben, verarbeitet und genutzt werden.</p>
			<p>Nähere Informationen über die Daten&shy;verarbeitung durch Google können Sie den <a href="https://www.google.com/intl/de_de/help/terms_maps.html">Google Maps Nutzerbedingungen</a> und der <a href="https://policies.google.com/privacy">Google Datenschutzerklärung</a> entnehmen; dort können Sie im Datenschutzcenter auch Ihre persönlichen Datenschutz-Einstellungen verändern.</p>
		</div>
	`;

	const toggle = document.querySelector('.consent-toggle button');
	if (toggle) {
		toggle.addEventListener('click', () => {
			callback();
		});
	}
};

if (mapElm) {
	if (localStorage.getItem('allow-map') === 'true') {
		initializeMap();
	} else {
		renderConsent(mapElm, () => {
			localStorage.setItem('allow-map', 'true');
			initializeMap();
		});
	}
}
